<template>
  <div >
    <app-header />
    <el-button type="primary" icon="el-icon-download" @click="indivi()" size="small" style="position: absolute;right: 30px;top:100px;z-index: 9;">pdf报告下载</el-button>
    <div class="pdfbox2_20 bgxq" id="pdfDom">
      <div class="pdfhead2_20" style="margin-top: 60px;">
        <img src="../assets/img/LOGO2_20.png" alt="" class="img">
        <span>医学生物特征认知专家</span>
      </div>
      <div class="pdftitle2_20">
        <div class="pdftitlename2_20">{{msg.name}}报告</div>
        <div class="pdftitlenameps2_20">（{{msg.dateCreate}}）</div>
      </div>
      <div class="pdfbianma2_20">
        <span>用户编码：{{info.id}}</span>
        <span>管理层级：{{info.dept.deptName}}</span>
      </div>
      <div class="userps2_20">
        <div class="uluserps2_20">
          <div class="li">姓名：{{info.userName}}</div>
          <div class="li">性别：{{info.sex==1?'男':'女'}}</div>
          <div class="li">年龄：{{info.remark}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">身高：{{info.userHeight}}cm</div>
          <div class="li">体重：{{info.userWeight}}kg</div>
          <div class="li">生日：{{info.birthday}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">手机：{{info.phone==''?'--':info.phone}}</div>
          <div class="li">实名认证：{{num==null?"未实名":'已实名认证'}}</div>
          <div class="li">身份证号：{{num==null?"--":num.cardId}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">{{msg.name}}病史：{{msg.strokeHistory?msg.strokeHistory:'--'}}</div>
          <div class="li" style="padding-right:30px;overflow : hidden;box-sizing: border-box;">过敏史：{{info.historyOfAllergy}}</div>
          <div class="li" v-if="info.sex==2">是否怀孕：{{info.gravida==2?'否':'是'}}</div>
        </div>
      </div>

          <div class="titles" style='  clear: both;display: inline-block;width:100%;'>评估结果</div>
          <div class="div4"  >

            <div class="div4D" v-for="val in msg.report" >
              <div class="div4D2">
                <div class="div4d3" :style="'color:'+val.gradeColor+';'">{{val.grade}}</div>
                <div class="div4d4">风险等级</div>
              </div>
              <div class="div4D1">
                <div class="div4d1" style="color: #000000;" >{{val.disName}}</div>
                <div class="div4d2">检查项目</div>
              </div>
            </div>

          </div>
           <div class="titles">总检建议</div>
           <div class="div5">
             <div v-for="vals in msg.report">
              <div class="div5D2">{{vals.disName}}</div>
             <div class="div5D3">{{vals.screenRecommend.value}}</div>
             </div>


           </div>









      <div style="clear: both;"></div>
    </div>
    <div style="clear: both;"></div>
    <app-footer />
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'
import { request } from '@/network/request'
import $ from 'jquery'
import canvg from 'canvg'
import JsPDF from 'jspdf'
import html2Canvas from 'html2canvas'

export default {
  name: "",
  data() {
    return {
      msg: { report: [{screenRecommend:{value:''}}], },
      info: { dept: {} },
      num:{},


    }
  },
  beforeRouteLeave(to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
    let _this = this;

    if(to.fullPath == '/topic'){


      _this.$router.go(-1);


    }
next()
  },

  mounted: function() {
    let _this = this;
    if (sessionStorage.getItem('topic') == 0) {
      _this.baogaops1();
    } else {
      _this.baogaops();
    }
 _this.usershi();
    request({
      url: '/system/user/profile/userInfo',
      method: 'get',
      params: {}
    }).then(res => {
      if (res.data.code == 200) {
        _this.info = res.data.data;
        if (_this.info.historyOfAllergy == "" || _this.info.historyOfAllergy == undefined) {
          _this.info.historyOfAllergy = "无";
        } else {
          var text = "",
          historyOfAllergy = null;
          _this.info.historyOfAllergy = JSON.parse(_this.info.historyOfAllergy);

          for (var s = 0; s < _this.info.historyOfAllergy.length; s++) {
            for (var i = 0; i < _this.info.historyOfAllergy[s].userAllergensList.length; i++) {
              if (_this.info.historyOfAllergy[s].userAllergensList[i].status == 1) {
                text += _this.info.historyOfAllergy[s].userAllergensList[i].name + " ";

              }

            }
            text += _this.info.historyOfAllergy[s].value;
          }

          _this.info.historyOfAllergy = text.substr(0,15)+'...';
        }
      } else {

      }

    })

  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
        usershi() {
      // console.log('submit!');
      let _this = this;
      request({
        url: '/professional/queryRealById',
        method: 'get',
        params: {
          /*'userId': sessionStorage.getItem("userId")*/
        }
      }).then(res => {

        if (res.data.code == 200) {

          _this.num = res.data.data;
        } else {

        }
      })
    },
    baogaops() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/viewReports',
        method: 'get',
        params: { reportId: localStorage.getItem('baogaoid') }
      }).then(res => {
        if (res.data.code == 200) {
           let arrY = res.data.data.report;
        for(let q =0;q < arrY.length;q++){
           _this.$set(arrY[q], 'disName', arrY[q].disName.substr(0,arrY[q].disName.length-1));
        }
          _this.msg = arrY;


        } else {

        }

      })

    },
    baogaops1() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/viewReport',
        method: 'get',
        params: { reportId: localStorage.getItem('baogaoid') }
      }).then(res => {
        if (res.data.code == 200) {


        _this.msg = res.data.data;
        let arrY = _this.msg.report;
        for(let q =0;q < arrY.length;q++){
           _this.$set(arrY[q], 'disName', arrY[q].disName.substr(0,arrY[q].disName.length-1));
        }

        } else {

        }

      })

    },
    indivi() {
      this.onclone();
    },
    // TODO:: SVG to canvas
    onclone() {
      let _this = this;
      // const svgElems = $('#svgcan').find('svg');
      // svgElems.each(function(index, node) {
      //   //获取svg的父节点
      //   var parentNode = node.parentNode;
      //   //获取svg的html代码
      //   var svg = node.outerHTML.trim();
      //   //创建一个<canvas>，用于放置转换后的元素
      //   var canvas = document.createElement('canvas');
      //   //将svg元素转换为canvas元素


      //   canvg(canvas, svg);
      //   canvas.style.height = '153px';
      //   canvas.style.position = 'absolute';
      //   canvas.style.left = '-76px';
      //   //删除svg元素
      //   parentNode.removeChild(node);
      //   //增加canvas元素
      //   parentNode.appendChild(canvas);
      //   _this.getPdf();
      // });
_this.getPdf();
    },
    getPdf() {

      var title = this.msg.name+'报告'; //this.title
      html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        scale: 1 // 提升画面质量，但是会增加文件大小
      }).then(function(canvas) {
        //  document.body.appendChild(canvas);
        // console.log(canvas)
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = contentWidth / 592.28 * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        console.log(pageData);
        let PDF = new JsPDF('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        };
        PDF.save(title + '.pdf');
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleClick(row) {
      console.log(row);
    },
    onSubmit() {
      console.log('submit!');
    }

  }

}

</script>
<style>
#svgcan {
  pointer-events: none;
}

.youqian2_25 {
  width: 50%;
  float: left;
  border-right: 1px solid #000;
}

.biaogeli2_20 .youqian2_25:nth-child(even) {
  border-right: none;
}

.pdfbox2_20 {
  width: 1200px;
  padding: 0 150px;
  box-sizing: border-box;
  background-color: #fff;
  /*float: left;*/
  margin: 60px auto;
}

.pdfhead2_20 {
  width: 100%;
  float: left;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  color: #C3C5C3;
  text-align: right;
  border-bottom: 5px solid #000;
}

.pdfhead2_20 .img {
  width: 98px;
  float: left;
  height: 24px;
  margin-top: 15px;
}

.pdftitle2_20 {
  width: 100%;
  padding: 20px 0;
  float: left;
  border-bottom: 5px solid #000;
}

.pdftitlename2_20 {
  width: 100%;
  float: left;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: center;
}

.pdftitlenameps2_20 {
  width: 100%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 16px;
  text-align: center;
}

.pdfbianma2_20 {
  width: 100%;
  padding: 10px 0;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;

}

.pdfbianma2_20 span:nth-child(1) {
  float: left;
}

.pdfbianma2_20 span:nth-child(2) {
  float: right;
}

.userps2_20 {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  float: left;
  border: 1px solid #000;
}

.uluserps2_20 {
  width: 100%;
  height: 42px;
  line-height: 42px;
  float: left;
}

.uluserps2_20 .li {
  width: 33.3%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.zhibaotitle2_20 {
  width: 100%;
  float: left;
  height: 50px;
  line-height: 50px;
  padding: 0 30px;
  box-sizing: border-box;
  background: #F5F5F5;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
}

.jiancexm2_20 {
  width: 100%;
  float: left;
  height: 53px;
  line-height: 53px;
  padding: 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* border-bottom: 1px solid #000;*/
}

.biage2_20 {
  width: 100%;
  float: left;
}

.biaogeul2_20 {
  width: 100%;
  float: left;
}

.biaogeli2_20 {
  width: 50%;
  float: left;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.biaogeli2_20 .li {
  width: 25%;
  height: 34px;
  line-height: 34px;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;

}

.fuyao2_20 {
  width: 100%;
  height: 34px;
  line-height: 34px;
  float: left;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.fuyao2_20 .li:nth-child(1) {
  width: 70%;
  float: left;
  padding: 0 30px;
  box-sizing: border-box;

}

.fuyao2_20 .li:nth-child(2) {
  width: 30%;
  float: left;
  padding: 0 30px;
  text-align: center;
  box-sizing: border-box;

}

.fuyao12_20 {
  width: 100%;

  float: left;
  border-bottom: 1px solid #000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;
}

.fuyao12_20 .li:nth-child(odd) {
  width: 70%;
  float: left;
  padding: 0 30px;
  box-sizing: border-box;
  height: 30px;
  line-height: 30px;

}

.fuyao12_20 .li:nth-child(even) {
  width: 30%;
  height: 30px;
  line-height: 30px;
  float: left;
  padding: 0 30px;
  text-align: center;
  box-sizing: border-box;

}

.pdftongjitu2_20 {
  width: 100%;
  float: left;
}

.pdftongjitu2_20 .li {
  width: 33.3%;
  float: left;
  text-align: center;
  position: relative;
}

.pdftongjitu2_20 .li .zhi {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF5429;
  margin-top: 74px;
}

.pdftongjitu2_20 .li .zhips {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 11px;
}

.pdftongjitu2_20 .li .tu {
  margin-top: 23px;
}

.pdftongjitu2_20 .li .tuzhi {
  width: 100%;
  position: absolute;
  left: 0;
  top: 74px;
  z-index: 999;
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF5429;
}

.pdftongjitu2_20 .li .tuzhips {
  width: 100%;
  position: absolute;
  left: 0;
  top: 113px;
  z-index: 999;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.jieguo2_20 {
  width: 100%;
  float: left;
  padding: 20px 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.weixian2_20 {
  width: 100%;
  padding: 10px 0;
  float: left;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.weixian2_20 .ul {
  width: 100%;
  float: left;
  padding: 10px 0;
}

.weixian2_20 .ul .li {
  width: 25%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;
}

.pdfyindao2_20 {
  width: 100%;
  float: left;
}

.pdfyindaotitle2_20 {
  width: 100%;
  float: left;
  padding: 20px 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.pdfyindaops2_20 {
  width: 100%;
  float: left;
  padding: 0 30px;
  text-indent: 2em;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 20px;
}

.dibu2_20 {
  width: 100%;
  height: 5px;
  float: left;
  margin: 20px 0;
  border-top: 5px solid #000;
  border-bottom: 1px solid #000;
  box-sizing: content-box;
}


.bgxq .el-dialog__body{
    padding: 30px 24px;
    padding-top: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.bgxq .div1{
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 28px;
}
.bgxq .div2{
  margin: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
  overflow: hidden;
}
.bgxq .div2D1{
  float: left;
}
.bgxq .div2D2{
  float: right;
}
.bgxq .div3{
  width: 100%;
  padding: 24px 24px;
  box-sizing: border-box;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  overflow: hidden;
}
.bgxq .div3D1{
  float: left;
  width: 100%;
  margin-bottom: 6px;
  box-sizing: border-box;
}
.bgxq .div3D2{
  float: left;
  width: 100%;
  box-sizing: border-box;
}
.bgxq .div3D1 div,.bgxq .div3D2 div{
  float: left;
  width: 33.3%;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
  text-align: left;
}
.bgxq .div3D1 span,.bgxq .div3D2 span{
  color: #000000;
}
.bgxq .titles{
  padding: 16px 24px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  background: #F5F5F5;
  text-align: left;
  margin: 24px 0;

}
.bgxq .div4{
  display:inline-block;
  overflow: hidden;
  margin: 24px 0;
  width: 100%;
}
.bgxq .div4D{
  overflow: hidden;
  margin-bottom: 12px;
}
.bgxq .div4D:nth-last-child(1){
  margin-bottom: 0;
}
.bgxq .div4D1,.bgxq .div4D2{
  float: left;
  width: 50%;
  box-sizing: border-box;
  text-align: center;
}
.bgxq .div4d1{
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FF3148;
  line-height: 28px;
  margin-bottom: 8px;
}
.bgxq .div4d2{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
}
.bgxq .div4d3{
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
}
.bgxq .div4d4{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
}
.bgxq .div4s1{
  color: #999999;
  font-size: 14px;
}
.bgxq .div5{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
  overflow: hidden;
  margin: 24px 0;
  padding: 0 24px;
  text-align: left;
}
.bgxq .div6{
  overflow: hidden;
  padding-bottom: 50px;
  text-align: center;
}
.bgxq .div6D1{
  width: 100%;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  overflow: hidden;
}
.bgxq .div6D2{
  display: inline-block;
  width: 100%;
  height: 1px;
  background-color: #E6E6E6;
  margin: 24px 0;
}
.bgxq .div6D1 div{
  float: left;
  box-sizing: border-box;

}
.bgxq .div6D3>div{
  float: left;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
  margin-bottom: 18px;
}
.bgxq .div6D3>div>div{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/zhpdf.vue